window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};
(function ($, Handlebars, slate) {
  if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }
  
  ShopifyAPI.addToCartFromForm = function ($form) {
    var promise = $.Deferred();
    $.ajax({
      url: '/cart/add.js',
      type: "post",
      dataType: "json",
      data: $form.serialize(),
      success: function (data) {
        ShopifyAPI.getCart().then(function (data) {
          promise.resolve(data);
        });
      },
      error: function (data) {
        console.log('error');
        promise.reject({
          message: 'Cart wasn\'t updated correctly'
        });
      }
    });

    return promise;
  };

  ShopifyAPI.getCart = function() {
     var promise = $.Deferred();
     
    $.ajax({
     type: 'get',
     dataType: 'json',
     url: '/cart.js',
     success: function (data) {
       var cart = data;
       promise.resolve(cart);
     },
     error: function (data) {
       promise.reject({
         message: 'Could not retrieve cart items'
       });
     }
    });

     return promise;
  };

  ShopifyAPI.addItemById = function (productId) {
    var promise = $.Deferred();
    $.ajax({
      url: '/cart/add.js',
      type: "post",
      dataType: "json",
      data: {
        id: productId,
        quantity: 1
      },
      success: function () {
        ShopifyAPI.getCart().then(function (data) {
          promise.resolve(data);
        })
      }
    });

    return promise
   };

  ShopifyAPI.changeItemQuantity = function(variantId, qty) {
    return $.ajax({
      type: 'post',
      dataType: 'json',
      url: '/cart/change.js',
      data: {
        quantity: qty,
        id: variantId
      }
    });
  };

  slate.AjaxCart = (function () {
    $window = $(window);
    $body = $('body');

    var selectors = {
      productForm: "form[action='/cart/add']",
      miniCart : "[data-mini-cart]",
      cartTemplate : "[data-cart-template]",
      cartToggler : "[data-cart-toggler]",
      cartBadge : "[data-cart-count-badge]",
      addToCartButton: "[data-add-to-cart-button]",
      removeItem: "[data-ajax-cart-item-remove]"
    }

    var classes = {
      cartOpen : "is-open",
      bodyCartOpen : "cart-is-open"
    }

    var initialized = false;


    function AjaxCart() {
      this.init = function () {
        if(initialized) return;

        this.$container = $(selectors.miniCart);
        this.$cartContent = $(selectors.miniCart).find('.ajax-cart');
        this.$cartBadge = $(selectors.cartBadge);

        $body.on('click', selectors.cartToggler, this.toggleCart.bind(this));
        $body.on('click', selectors.addToCartButton, this.quickAddToCart.bind(this));
        $body.on('click', selectors.removeItem, this.removeItem.bind(this));

        this.template = Handlebars.compile($(selectors.cartTemplate).html());

        ShopifyAPI.getCart().then(this.buildCart.bind(this));
        $(selectors.productForm).on('submit', this.ajaxFormSubmit.bind(this));

      }

      return this;

    }

    AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

      ajaxFormSubmit: function (e) {
        var _this = this;
        e.preventDefault();
        var $form = $(e.currentTarget);
        var productData = $form.serialize();

        ShopifyAPI.addToCartFromForm($form).then(
          function (data) {
            _this.buildCart.call(_this, data);
            _this.open();
          }
        );
      },

      buildCart: function(cart) {

        // Make adjustments to the cart object contents before we pass it off to the handlebars template
        cart.total_price = slate.Currency.formatMoney(cart.total_price, theme.moneyFormat);
        // cart.total_price = slate.Currency.stripZeroCents(cart.total_price);

        cart.items.map(function(item){
          item.image    = slate.Image.getSizedImageUrl(item.image, '200x');
          item.price    = slate.Currency.formatMoney(item.price, theme.moneyFormat);
          // item.price = slate.Currency.stripZeroCents(item.price);

          // Adjust the item's variant options to add "name" and "value" properties
          if(item.hasOwnProperty('product')) {
            var product = item.product;
            for (var i = item.variant_options.length - 1; i >= 0; i--) {
              var name  = product.options[i];
              var value = item.variant_options[i];

              item.variant_options[i] = {
                name: name,
                value: value
              };

              // Don't show this info if it's the default variant that Shopify creates
              if(value == "Default Title") {
                delete item.variant_options[i];
              }
            }
          }
          return item;
        });

        /**
         *  You can also use this as an intermediate step to constructing the AJAX cart DOM
         *  by returning an HTML string and using another function to do the DOM updating
         *
         *  return this.template(cart)
         *
         *  The code below isn't the most elegant way to update the cart but it works...
         */        
        this.$cartContent.empty().append( this.template(cart) );
        this.updateBadges(cart);
      },

      toggleCart: function (e) {
        e.preventDefault();
        if (this.$container.hasClass(classes.cartOpen)) {
          this.close();
        }else{
          this.open();
        }
      },

      updateBadges: function (cart) {
        $(selectors.cartBadge).text(cart.item_count);
      },

      quickAddToCart: function (e) {
        e.preventDefault();
        $el = $(e.target);
        var _this = this;
        var productId = $el.data('product-id');
        var cart = ShopifyAPI.getCart();

        ShopifyAPI.addItemById(productId).then(function (data) {
            _this.buildCart.call(_this, data);
            _this.open();
          });

      },

      removeItem:function (e) {
        e.preventDefault();
        var $el = $(e.currentTarget);
        var _this = this;
        var productId = $el.data('id');

        ShopifyAPI.changeItemQuantity(productId, 0).then(
          function (data) {
            _this.buildCart.call(_this, data);
        });
      },

      open: function () {
        this.$container.addClass(classes.cartOpen);
      },
      close: function () {
        this.$container.removeClass(classes.cartOpen);
      }
    });

    return AjaxCart;

  })();

})(jQuery, Handlebars, slate);
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },  

  toggle: function (target, classname) {
    $(target).toggleClass(classname);
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;
        var options = variant.options;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
theme.Header = (function ($) {
  
  var $document = $(document);
  var $body = $(document.body);
  var $window = $(window);

  var selectors = {
    header: "[data-header]",
    topHeader: "[data-top-header]",
    mobileMenuOpen: "[data-mobile-menu-opener]",
    mobileMenuClose: "[data-mobile-menu-closer]",
    mobileMenu: "[data-mobile-menu]",
    mobileSearchToggler: "[data-mobile-search]",
    mobileSearchForm: "[data-mobile-search-form]",
    desktopSearchForm: "[data-desktop-search-form]",
    desktopSearchOpen: "[data-desktop-search-opener]",
    desktopSearchClose: "[data-desktop-search-closer]",
    miniCartOpener: "[data-cart-opener]",
    dataMiniCart: "[data-mini-cart]",
    dropdownTrigger: "[data-dropdown-toggler] > a"
  }

  var classes = {
    headerFixed: 'navbar-fixed-top',
    siteHasHeaderFixed: 'site-header-fixed',
    open: 'slidingIn',
    noScroll: 'no-scroll',
    searchOpened: 'search-opened'
  }

  function Header(container) {

    this.cart = new slate.AjaxCart();
    
    this.$container = $(container);

    this.name = 'header',
    this.namespace = '.'+this.name;

    this.$el = $(selectors.header, this.$container);

    this.events = {
      SCROLL: "scroll" + this.namespace
    }

    this.onScroll();

    $document.on(this.events.SCROLL, $.throttle(30, this.onScroll.bind(this)));
    this.$container.on('click',  selectors.mobileMenuOpen, this.mobileMenuOpen.bind(this));
    this.$container.on('click',  selectors.mobileMenuClose, this.mobileMenuClose.bind(this));
    this.$container.on('click',  selectors.mobileSearchToggler, this.openMobileSearch.bind(this));
    this.$container.on('click',  selectors.desktopSearchOpen, this.openDesktopSearch.bind(this));
    this.$container.on('click',  selectors.desktopSearchClose, this.closeDesktopSearch.bind(this));
    this.$container.on('click',  selectors.dropdownTrigger, this.openDropdowns.bind(this));
  };

  Header.prototype = $.extend({}, Header.prototype, {
    openDropdowns: function (e) {
      if (window.matchMedia('(max-width: 991px)').matches) {
        e.preventDefault();
        var $this = $(e.currentTarget);
        var dropdownToggle = $this.parents('.dropdown').find('.dropdown-toggle');
        var dropdownMenu = $this.parents('.dropdown').find('.dropdown-menu');
        $this.parents('.dropdown').toggleClass('open');
        $(dropdownToggle).toggleClass('open');
        $(dropdownMenu).toggleClass('dropdown');
      }
    },
    onScroll: function () {
      var topBannerHeight = $(selectors.topHeader).outerHeight();
      var $header = $(selectors.header);
      var offsetTop;

      if ($(selectors.topHeader).is(':visible')) {
        offsetTop = topBannerHeight;
      }else{
        offsetTop = 0;
      }

      if ($window.scrollTop() >= offsetTop && !this.$container.hasClass(classes.headerFixed)) {
        var headerHeight = this.$container.outerHeight();
        this.$container.addClass(classes.headerFixed);
        $body.addClass(classes.siteHasHeaderFixed);
        $body.css('padding-top', headerHeight);
      }else if($window.scrollTop() <= offsetTop && this.$container.hasClass(classes.headerFixed)){
        var headerHeight = this.$container.outerHeight();
        this.$container.removeClass(classes.headerFixed);
        $body.removeClass(classes.siteHasHeaderFixed);
        $body.css('padding-top', 0);
      }
    },
    mobileMenuOpen: function(e) {
      $(selectors.mobileMenu, this.$container).addClass(classes.open);
      $body.addClass(classes.noScroll);
    },
    mobileMenuClose: function(e) {
      $(selectors.mobileMenu, this.$container).removeClass(classes.open);
      $body.removeClass(classes.noScroll);
    },
    openMobileSearch: function () {
      this.mobileMenuOpen();
      $(selectors.mobileSearchForm).find('input[type=text]').focus();
    },
    openDesktopSearch: function () {
      var $header = $(selectors.header);
      var $searchForm = $(selectors.desktopSearchForm);
      $header.addClass(classes.searchOpened);

      $searchForm.find('input[type=text]').focus();
    },
    closeDesktopSearch: function () {
     var $header = $(selectors.header);
     $header.removeClass(classes.searchOpened); 
    }
  });

  return Header;

})(jQuery)
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    productIncrease: '[data-product-increase]',
    productDecrease: '[data-product-decrease]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));


    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    this.initVariants();
    this.$container.on('click', selectors.productIncrease, this.increaseQuantity.bind(this));
    this.$container.on('click', selectors.productDecrease, this.decreaseQuantity.bind(this));
    this.$container.on('click', selectors.productThumbs, this.thumbnailChange.bind(this));
  }

  Product.prototype = $.extend({}, Product.prototype, {
    thumbnailChange: function(event) {
      event.preventDefault();
      var $this = $(event.currentTarget);
      var url = $this.attr('href');
      $(selectors.productFeaturedImage).attr('src', url);
    },

    increaseQuantity: function () {
      var $quantityInput = $('#Quantity');
      var currentQty = parseInt($quantityInput.val());

      $quantityInput.val( currentQty + 1 );
    },

    decreaseQuantity: function () {
      var $quantityInput = $('#Quantity');
      var currentQty = parseInt($quantityInput.val());

      if (currentQty > 1) {
        $quantityInput.val( currentQty - 1 );
      }
    },

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.Slideshow = (function ($) {
  
  var selectors = {
    slideshow: '[data-slideshow]'
  }

  var classes = {
  }

  function Slideshow(container) {
    
    this.$container = $(container);
    this.$slideshow = $(selectors.slideshow, this.$container);

    this.name = 'slideshow',
    this.namespace = '.'+this.name;

    this.$el = $(selectors.header, this.$container);
    this.settings = {
      arrows: this.$slideshow.data('arrows'),
      fade: this.$slideshow.data('fade'),
      speed: this.$slideshow.data('transition'),
      autoplay: this.$slideshow.data('autoplay'),
      slide: this.$slideshow.data('slide-selector'),
      nextArrow: this.$slideshow.find('[data-next-arrow]'),
      prevArrow: this.$slideshow.find('[data-previous-arrow]')
    }

    $(selectors.slideshow, this.$container).slick(this.settings);

  };

  Slideshow.prototype = $.extend({}, Slideshow.prototype, {
    /**
     * Theme Editor section events below
     */
    onBlockSelect: function(evt) {
      this.goToSlideByBlockId( evt.detail.blockId );
      this.$slideshow.slick('slickPause');
    },
    goToSlideByBlockId: function (id) {
      var slick = this.$slideshow.slick('getSlick');
      var $slide = slick.$slides.filter('[data-block-id="' + id + '"]:not(.slick-cloned)');
      var slideIndex = $slide.data("slick-index");
      console.log(slideIndex);
      this.$slideshow.slick('slickGoTo', slideIndex );
    }
  });

  return Slideshow;

})(jQuery)
theme.ProductGrid = (function ($) {
  
  var selectors = {
    slideshow: '[data-slideshow]',
    addToCart: '[data-add-to-cart-button]'
  }

  var classes = {
  }

  function ProductGrid(container) {
    
    this.$container = $(container);
    this.$slideshow = $(selectors.slideshow, this.$container);

    this.name = 'productGrid',
    this.namespace = '.'+this.name;

    this.$el = $(selectors.header, this.$container);
    this.settings = {
      arrows: true,
      speed: this.$slideshow.data('transition'),
      autoplay: this.$slideshow.data('autoplay'),
      slide: this.$slideshow.data('slide-selector'),
      slidesToShow: this.$slideshow.data('slides-to-show'),
      nextArrow: this.$slideshow.find('[data-next-arrow]'),
      prevArrow: this.$slideshow.find('[data-previous-arrow]'),
      responsive: [
          {
          "breakpoint": 990,
          "settings":{
            slidesToShow: 2
          }
        }
      ]
    }

    if ($(selectors.slideshow, this.$container).lenght < 1) {
      console.error('['+this.namespace+'] could not be initialized at least one '+selectors.slideshow+' should be defined on the container');
    }

    $(selectors.slideshow, this.$container).slick(this.settings);

  };

  ProductGrid.prototype = $.extend({}, ProductGrid.prototype, {
    /**
     * Theme Editor section events below
     */
    onUnload: function (evt) {
      $(selectors.slideshow, this.$container).slick(this.settings);
    },
    onBlockSelect: function(evt) {
      this.goToSlideByBlockId( evt.detail.blockId );
      this.$slideshow.slick('slickPause');
    },
    goToSlideByBlockId: function (id) {
      var slick = this.$slideshow.slick('getSlick');
      var $slide = slick.$slides.filter('[data-block-id="' + id + '"]:not(.slick-cloned)');
      var slideIndex = $slide.data("slick-index");
      this.$slideshow.slick('slickGoTo', slideIndex );
    }
  });

  return ProductGrid;

})(jQuery)
theme.AjaxCart = (function($) {

  var $body = $(document.body);

  /**
   * AjaxCart section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   *
   * @param {string} container - selector for the section container DOM element
   */
  function AjaxCart(container) {
    this.$container = $(container);

    this.name = 'ajaxCart',
    this.namespace = '.'+this.name;

    this.ajaxCart = new slate.AjaxCart();

    if (!$body.hasClass('template-cart')) {
      this.ajaxCart.init();      
    }
  }

  AjaxCart.prototype = $.extend({}, AjaxCart.prototype, {

    /**
     * Theme Editor section events below
     */
    onSelect: function() {
      this.ajaxCart.open();
    },

    onDeselect: function() {
      this.ajaxCart.close();
    },

    onShow: function() {

    },

    onLoad: function() {

    },

    onUnload: function() {

    }
  });

  return AjaxCart;
})(jQuery);


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('header-section', theme.Header);
  sections.register('slideshow', theme.Slideshow);
  sections.register('product-grid', theme.ProductGrid);
  sections.register('ajax-cart', theme.AjaxCart);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  $('[data-toggle]').on('click', function () {
    var toggledClass = $(this).data('toggle');

    if (toggledClass == 'collapse') {
      return;
    }

    var target = $(this).data('target');

    slate.utils.toggle(target, toggledClass);
  })
});
